import React from "react";
import { ReactComponent as UpDownIcon } from "../../../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../../../assets/images/up-down-icon_v1.svg";
import { formatNumber } from "../../../../../services/utility/utils";
import useDeviceDetect from "../../../../../hook/useDeviceDetect";
import { formatNumberForOdds } from "../../../../../utils/utils";

export default function YouBet(props: any) {
  const { isBet, betAbove, operatorId, odds, valueBet, lang } = props;
  const { isTablet } = useDeviceDetect();
  return (
    <div
      className={`wrap-item wrap-item-you-bet ${
        isBet
          ? `${betAbove && "wrap-item-above"} ${!betAbove && "wrap-item-below"}`
          : ""
      }
      animate__animated
      ${isTablet ? "animate__zoomIn" : "animate__fadeInRight animate-delay-02"}
      
      `}
    >
      {!isBet && (
        <div className="content-not-bet">
          {lang?.no_bets || "No bets"} <br /> {lang?.placed || "placed"}
        </div>
      )}
      {isBet && (
        <div className="wrap-value-bet">
          <div className="wrap-bet-icon">
            <div className={`wrap-icon-${betAbove ? "above" : "below"}`}>
              {/* {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />} */}
              <UpDownIcon />
            </div>
            <p className="label-bet">
              {lang?.you_bet || "You bet"} <span>${formatNumber(valueBet,2)}</span>{" "}
              {lang?.to_win || "to win"}
            </p>
          </div>
          <p className="value-bet">
            <span>$</span> {formatNumberForOdds(valueBet * odds)}
          </p>

          <p className="value-odds">{lang?.odds ||  "Odds"} {formatNumberForOdds(odds)}</p>
        </div>
      )}
    </div>
  );
}
